export function getLinkTypes(guideline) {
  switch (guideline) {
    case 'iRECIST': {
      return [
        { value: 'TARGET', label: 'Target' },
        { value: 'NON-TARGET', label: 'Non-target' },
        { value: 'NL-TARGET', label: 'New (Target)' },
        { value: 'NL-NON-TARGET', label: 'New (Non-target)' },
        { value: 'LINK', label: 'Link' },
      ];
    }
    case 'RECIP10': {
      return [
        { value: 'LESION', label: 'Lesion' },
        { value: 'NEW', label: 'New' },
        { value: 'BACKGROUND', label: 'Background' },
        { value: 'LINK', label: 'Link' },
      ];
    }
    default: {
      return [
        { value: 'TARGET', label: 'Target' },
        { value: 'NON-TARGET', label: 'Non-target' },
        { value: 'NEW', label: 'New' },
        { value: 'LINK', label: 'Link' },
      ];
    }
  }
}

export function getResponseTypes(guideline) {
  switch (guideline) {
    case 'iRECIST': {
      return {
        TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'iCR', label: 'iCR' },
          { value: 'iPR', label: 'iPR' },
          { value: 'iSD', label: 'iSD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NON_TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'iCR', label: 'iCR' },
          { value: 'NON-iCR/NON-iUPD', label: 'Non-iCR/Non-iUPD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NEW_LESION_TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'iCR', label: 'iCR' },
          { value: 'iPR', label: 'iPR' },
          { value: 'iSD', label: 'iSD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        NEW_LESION_NON_TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'iCR', label: 'iCR' },
          { value: 'NON-iCR/NON-iUPD', label: 'Non-iCR/Non-iUPD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        USE_OF_STEROIDS: [
          { value: 'TBD', label: '------' },
          { value: 'N/A', label: 'N/A' },
        ],
        CLINICAL_STATUS: [
          { value: 'TBD', label: '------' },
          { value: 'N/A', label: 'N/A' },
          { value: 'Worse', label: 'Worse' },
          { value: 'Stable', label: 'Stable' },
          { value: 'Improved', label: 'Improved' },
        ],
        OVERALL_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'iCR', label: 'iCR' },
          { value: 'iPR', label: 'iPR' },
          { value: 'iSD', label: 'iSD' },
          { value: 'NON-iCR/NON-iUPD', label: 'Non-iCR/Non-iUPD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
      };
    }
    case 'RECIST11': {
      return {
        TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NON_TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'CR', label: 'CR' },
          { value: 'NON-CR/NON-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NEW_LESION_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'Unequivocal', label: 'Unequivocal' },
          { value: 'Equivocal', label: 'Equivocal' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        USE_OF_STEROIDS: [
          { value: 'TBD', label: '------' },
          { value: 'N/A', label: 'N/A' },
        ],
        CLINICAL_STATUS: [
          { value: 'TBD', label: '------' },
          { value: 'N/A', label: 'N/A' },
        ],
        OVERALL_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'NON-CR/NON-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
      };
    }
    case 'RECIP10': {
      return {
        PSMA_VOL_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'PSMA-VOL-CR', label: 'PSMA-VOL-CR' },
          { value: 'PSMA-VOL-PR', label: 'PSMA-VOL-PR' },
          { value: 'PSMA-VOL-SD', label: 'PSMA-VOL-SD' },
          { value: 'PSMA-VOL-PD', label: 'PSMA-VOL-PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NEW_LESION_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'Present', label: 'Present' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        OVERALL_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'RECIP-CR', label: 'RECIP-CR' },
          { value: 'RECIP-PR', label: 'RECIP-PR' },
          { value: 'RECIP-SD', label: 'RECIP-SD' },
          { value: 'RECIP-PD', label: 'RECIP-PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
      };
    }
    default: {
      return {
        TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NON_TARGET_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'CR', label: 'CR' },
          { value: 'NON-CR/NON-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NEW_LESION_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'Unequivocal', label: 'Unequivocal' },
          { value: 'Equivocal', label: 'Equivocal' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        USE_OF_STEROIDS: [
          { value: 'TBD', label: '------' },
          { value: 'N/A', label: 'N/A' },
          { value: 'None', label: 'None' },
          { value: 'Decreased', label: 'Decreased' },
          { value: 'Stable', label: 'Stable' },
          { value: 'Increased', label: 'Increased' },
        ],
        CLINICAL_STATUS: [
          { value: 'TBD', label: '------' },
          { value: 'N/A', label: 'N/A' },
          { value: 'Worse', label: 'Worse' },
          { value: 'Stable', label: 'Stable' },
          { value: 'Improved', label: 'Improved' },
        ],
        OVERALL_RESPONSE: [
          { value: 'TBD', label: '------' },
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'NON-CR/NON-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
      };
    }
  }
}

export function getLinkLocations(guideline='default') {
  switch(guideline){
    case 'RECIP10':
      return RECIP_LINK_LOCATIONS;
    default:
      return LINK_LOCATIONS;
  }
}

const LINK_LOCATIONS = [
  { value: 'BRAIN', label: 'Brain' },
  { value: 'BONE', label: 'Bone' },
  { value: 'NECK', label: 'Neck' },
  { value: 'LUNG', label: 'Lung' },
  { value: 'LYMPH_NODE', label: 'Lymph Node' },
  { value: 'MEDIASTINUM', label: 'Mediastinum' },
  { value: 'CHEST_WALL', label: 'Chest Wall' },
  { value: 'PLEURA', label: 'Pleura' },
  { value: 'PLEURAL_CAVITY', label: 'Pleural Cavity' },
  { value: 'LIVER', label: 'Liver' },
  { value: 'KIDNEY', label: 'Kidney' },
  { value: 'ADRENAL_GLAND', label: 'Adrenal Gland' },
  { value: 'PERITONEUM', label: 'Peritoneum' },
  { value: 'PERITONEAL_CAVITY', label: 'Peritoneal Cavity' },
  { value: 'RETROPERITONEUM', label: 'Retroperitoneum' },
  { value: 'OMENTUM', label: 'Omentum' },
  { value: 'PELVIS', label: 'Pelvis' },
];

const RECIP_LINK_LOCATIONS = [
  { value: 'BRAIN', label: 'Brain' },
  { value: 'BONE', label: 'Bone' },
  { value: 'NECK', label: 'Neck' },
  { value: 'LUNG', label: 'Lung' },
  { value: 'LYMPH_NODE', label: 'Lymph Node' },
  { value: 'MEDIASTINUM', label: 'Mediastinum' },
  { value: 'CHEST_WALL', label: 'Chest Wall' },
  { value: 'PLEURA', label: 'Pleura' },
  { value: 'PLEURAL_CAVITY', label: 'Pleural Cavity' },
  { value: 'LIVER', label: 'Liver' },
  { value: 'KIDNEY', label: 'Kidney' },
  { value: 'ADRENAL_GLAND', label: 'Adrenal Gland' },
  { value: 'PERITONEUM', label: 'Peritoneum' },
  { value: 'PERITONEAL_CAVITY', label: 'Peritoneal Cavity' },
  { value: 'RETROPERITONEUM', label: 'Retroperitoneum' },
  { value: 'OMENTUM', label: 'Omentum' },
  { value: 'PELVIS', label: 'Pelvis' },
  { value: 'SOFT_TISSUE', label: 'Soft Tissue' },
  { value: 'ABDOMEN', label: 'Abdomen' },
  { value: 'REF-LIVER', label: 'Ref-Liver' },
  { value: 'REF-BLOODPOOL', label: 'Ref-Bloodpool' },
];

export default {
  getLinkTypes,
  getLinkLocations,
  getResponseTypes,
};
